module.exports = __webpack_public_path__ + "static/germaniabrunnen-94a42a37ed62d3fdd20189fe884fdaa4.png";